import {Component, Input, NgZone, OnInit} from '@angular/core';
import {ComponentAsElement} from '../../../services/common/bootstrap/annotation/component-as-element';
import {TranslationService} from '../../../services/translation.service';
import {StaticModalsService} from '../../../components/common-modal/static-modals.service';

@ComponentAsElement('v-config-element')
@Component({
  selector: 'v-config',
  template: '',
  styles: ['']
})
export class ConfigComponent implements OnInit {

  @Input()
  public language: string;

  @Input()
  public country: string;


  constructor(
    private translationService: TranslationService,
    private _ngZone: NgZone,
    private staticModalsService: StaticModalsService
  ) {
    window['RootComponentRef'] = {zone: _ngZone};
    window['StartModal'] = (
      _modalName,
      _data
    ) => {
      this.staticModalsService.show(_modalName, _data);
    };
  }

  ngOnInit() {
    this.validateIfSetLocalization();
    this.translationService.setTranslation(this.language, this.country);
  }

  private validateIfSetLocalization() {
    if (!this.language || !this.country) {
      throw new Error('Element [name="v-config-localization"] should have set "language" and "country"');
    }
  }

}
